import { useCallback, useEffect, useRef, useState } from 'react';

export const OTP_EXPIRY_SECONDS = 300;

export function useOtpTimer(durationSeconds = OTP_EXPIRY_SECONDS) {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const timerRef = useRef(null);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startTimer = useCallback(() => {
    clearTimer();
    setSecondsLeft(durationSeconds);

    timerRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }, [clearTimer, durationSeconds]);

  const resetTimer = useCallback(() => {
    clearTimer();
    setSecondsLeft(0);
  }, [clearTimer]);

  useEffect(() => () => clearTimer(), [clearTimer]);

  const canResend = secondsLeft === 0;
  const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const seconds = String(secondsLeft % 60).padStart(2, '0');
  const formattedTime = `${minutes}:${seconds}`;

  return {
    secondsLeft,
    canResend,
    formattedTime,
    startTimer,
    resetTimer,
  };
}
